import React from 'react';
import { connect } from 'react-redux';

import { useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { LayoutSingleColumn, Page } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import LegalDocument from '../_marketingPage/LegalDocument';

import userTermsDocument from './userTermsDocument';

/**
 * The user terms ("Brukervilkår for Zuprize"), `/brukervilkar`.
 *
 * One set of terms for private sellers and Zuprize Partners alike. The text
 * is the client's document (Brukervilkar_Zuprize_Versjon21.docx), verbatim,
 * in the UserTermsPage.* translation keys: the "Kort fortalt" box, then
 * 24 numbered sections.
 *
 * @param {Object} props
 * @param {boolean} props.scrollingDisabled
 * @returns {JSX.Element}
 */
const UserTermsPageComponent = props => {
  const intl = useIntl();
  const { scrollingDisabled } = props;

  return (
    <Page
      title={intl.formatMessage({ id: 'UserTermsPage.metaTitle' })}
      description={intl.formatMessage({ id: 'UserTermsPage.metaDescription' })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="UserTermsPage" />}
        footer={<FooterContainer />}
      >
        <LegalDocument document={userTermsDocument} />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const UserTermsPage = connect(mapStateToProps)(UserTermsPageComponent);

export { UserTermsPageComponent };
export default UserTermsPage;
